import { useMutation, useQueryClient } from 'react-query';
import Modal from '../../../../../../commons/Modal/Modal';
import Button from '../../../../../../designSystem/Button/Button';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  CloseConsultationModalProps,
  CloseConsultationQuery,
} from './CloseConsultationModal.types';
import { useNavigate } from 'react-router-dom';
import {
  CLOSE_CONSULTATION_QUERY_KEY,
  closeConsultationQuery,
} from './CloseConsultationModal.query';

export default ({ consultationId, ...props }: CloseConsultationModalProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, CloseConsultationQuery>(
    ({ consultationId }) => closeConsultationQuery({ consultationId }),
    {
      mutationKey: CLOSE_CONSULTATION_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  return (
    <Modal style={{ height: 'fit-content' }} {...props}>
      <p>Êtes-vous sûr de vouloir mettre fin à cette consultation ?</p>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        onClick={() => mutate({ consultationId })}>
        Oui
      </Button>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        onClick={() => props.setOpen(false)}>
        Non
      </Button>
    </Modal>
  );
};
